import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { ChatBubbleOutline } from '@mui/icons-material';

interface TruncatedTextProps {
  text: string | null;
  maxLength?: number;
}

/**
 * 長いテキストを切り詰めて表示する共通コンポーネント
 * 指定文字数を超える場合はTooltipで全文を表示
 */
const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxLength = 20
}) => {
  if (!text) {
    return <span>-</span>;
  }
  if (text.length <= maxLength) {
    return <span>{text}</span>;
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <span>{text.slice(0, maxLength)}...</span>
      <Tooltip title={text} arrow placement="top">
        <ChatBubbleOutline sx={{ fontSize: 16, color: 'text.secondary', cursor: 'pointer' }}/>
      </Tooltip>
    </Box>
  );
};
export default TruncatedText;
